import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'be-list-element-rating',
  templateUrl: './list-element-rating.component.html',
  styleUrls: ['./list-element-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListElementRatingComponent {
  @Input() value!: number;
  @Input() votes!: number;

  scale = 5;
  data = Array(this.scale);
}
